module.exports = __webpack_public_path__ + "static/img/nh.36d893c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nh.png
// module id = pQLT
// module chunks = 1